import MenuShell from "@/components/menu-shell";
import styles from "@/components/menu.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { closeMenu, isDivider } from "@/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { JSX, MouseEvent } from "react";

function Menu(): JSX.Element {
	const handleCloseMenu = (): void => {
		void closeMenu();
	};

	const menu = signals.menu.value;
	const menuItemElements = menu?.items.map((menuItem, index) => {
		if (isDivider(menuItem)) {
			return (
				<div
					key={index}
					className={clsx(
						styles["menu-divider"],
						signals.generalSettings.value.isLiteModeEnabled &&
							styles["lite"],
					)}
				></div>
			);
		}

		const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
			void globals.menuCallbacks[menuItem.id || menuItem.text]?.(event);
			handleCloseMenu();
		};

		return (
			<button
				aria-disabled={menuItem.isDisabled}
				aria-haspopup={menuItem.hasPopup ? "dialog" : undefined}
				key={menuItem.id || menuItem.text}
				className={clsx(
					styles["menu-item"],
					menuItem.isDangerous && styles["danger"],
				)}
				onClick={handleClick}
				type="button"
			>
				<div className={styles["menu-content-left"]}>
					{menuItem.icon &&
						(typeof menuItem.icon === "string" ? (
							<i className={styles["menu-icon"]}>
								{menuItem.icon}
							</i>
						) : (
							<FontAwesomeIcon
								className={styles["menu-icon"]}
								icon={menuItem.icon}
								fixedWidth
							/>
						))}
					{menuItem.html ? (
						<div
							className={styles["menu-text"]}
							dangerouslySetInnerHTML={{ __html: menuItem.html }}
						></div>
					) : (
						<div className={styles["menu-text"]}>
							{menuItem.text}
						</div>
					)}
				</div>
				{menuItem.shortcut && (
					<div className={styles["shortcut-tip"]}>
						{menuItem.shortcut}
					</div>
				)}
			</button>
		);
	});

	return (
		<MenuShell
			className={clsx(
				styles["menu-container"],
				menu?.shouldBeLighterInDarkTheme &&
					styles["lighter-background"],
			)}
			isClosingMenu={signals.isClosingMenu.value}
			isModal={menu?.isModal || false}
			onClose={handleCloseMenu}
			show={menu !== null}
			x={menu?.x || 0}
			y={menu?.y || 0}
		>
			{menuItemElements}
		</MenuShell>
	);
}

export default Menu;
